<template>
    <div class="container-fluid">
        <Breadcrumb title="Add Tag" v-bind:button-show="false" v-show="!id"></Breadcrumb>
        <Breadcrumb v-bind:title="'Edit Tag #' + this.id" v-bind:button-show="false" v-show="id"></Breadcrumb>

        <div class="row" style="position: relative">
            <div class="col-12 row-preloader" v-if="id">
                <Preloader v-bind:class="{preloader: loading}" v-show="loading"></Preloader>
            </div>
            <div class="col-12" v-show="!loading">
                <div class="card">
                    <div class="card-body">
                        <TagForm :id="id" @hidePreloader="hidePreloader"></TagForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Preloader from '../components/Preloader';
    import TagForm from './forms/TagForm';
    import Breadcrumb from '../components/Breadcrumb';

    export default {
        name: 'Tag',
        props: ['id'],
        components: {Preloader, TagForm, Breadcrumb},
        data() {
            return {
                loading: false
            }
        },
        mounted() {
            if (this.id) {
                this.loading = true;
            }
        },
        methods: {
            hidePreloader(value) {
                this.loading = !value
            }
        }
    }
</script>

<style scoped>

</style>